import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<PageLoader />",{ moduleName: "cio/pods/sql-imports/loading/template.hbs" })